import {Component, Inject, OnInit} from "@angular/core";
import {OKTA_AUTH} from "@okta/okta-angular";
import OktaAuth from "@okta/okta-auth-js";

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    standalone: false
})
export class LoginComponent implements OnInit {
	constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth) {
	}

	ngOnInit() {
		this.oktaAuth.signInWithRedirect({originalUri: "/home"});
	}
}
